class ProductCarousel extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    new IntersectionObserver(this.handleAsyncMethods.bind(this), {
      rootMargin: "0px 0px 400px 0px"
    }).observe(this);
  }
  handleAsyncMethods(entries, observer) {
    if (!entries[0].isIntersecting)
      return;
    observer.unobserve(this);
    this.handleDynamicRecommendations();
  }
  /**
   * Handles dynamically fetching and setting product recommendations if set
   * @returns Promise<void>
   */
  async handleDynamicRecommendations() {
    if (!this.dataset.url) {
      return;
    }
    try {
      const response = await fetch(this.dataset.url);
      const text = await response.text();
      const html = document.createElement("div");
      html.innerHTML = text;
      const recommendations = html.querySelector("uwp-product-carousel");
      if (!recommendations || !recommendations.innerHTML.trim().length) {
        return;
      }
      this.innerHTML = recommendations.innerHTML;
      this.reinitialiseCarousel();
    } catch (error) {
      throw new Error(error);
    }
  }
  reinitialiseCarousel() {
    const carousel = this.querySelector("uwp-carousel");
    if (!carousel) {
      return;
    }
    carousel.createCarousel();
  }
}
customElements.define("uwp-product-carousel", ProductCarousel);
